import { render, staticRenderFns } from "./OrganizationViewOptions.vue?vue&type=template&id=167440e8&scoped=true"
import script from "./OrganizationViewOptions.vue?vue&type=script&lang=js"
export * from "./OrganizationViewOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167440e8",
  null
  
)

export default component.exports